export { setPageContextCurrent };
export { getPageContextCurrent };
import { getGlobalObject } from './utils.js';
const globalObject = getGlobalObject('runtime-client-routing/getPageContextCurrent.ts', {
    pageContextCurrent: null,
});
function getPageContextCurrent() {
    const { pageContextCurrent } = globalObject;
    return pageContextCurrent;
}
function setPageContextCurrent(pageContextCurrent) {
    globalObject.pageContextCurrent = pageContextCurrent;
}
